import { ViewMode } from '@mobile-mapping/web3d';
import { PaneLayouts } from '@trimble/pane-layout';

export const PANE_LAYOUT: PaneLayouts<ViewMode> = {
  version: '5',
  activeLayoutLabel: 'Single',
  layouts: [
    {
      label: 'Single',
      paneRows: [
        {
          config: {
            size: 1,
            minSize: 0.2,
          },
          cells: [
            {
              contentConfig: { type: '3D' },
              size: 1,
              minSize: 0.2,
            },
          ],
        },
      ],
    },
    {
      label: '1+1',
      paneRows: [
        {
          config: {
            size: 1,
            minSize: 0.2,
          },
          cells: [
            {
              contentConfig: { type: '3D' },
              size: 0.5,
              minSize: 0.2,
            },
            {
              contentConfig: { type: '2D' },
              size: 0.5,
              minSize: 0.2,
            },
          ],
        },
      ],
    },
    {
      label: '1+2',
      paneRows: [
        {
          config: {
            size: 0.5,
            minSize: 0.2,
          },
          cells: [
            {
              contentConfig: { type: '3D' },
              size: 1,
              minSize: 0.2,
            },
          ],
        },
        {
          config: {
            size: 0.5,
            minSize: 0.2,
          },
          cells: [
            {
              contentConfig: { type: 'Image', cameraIndex: 0 },
              size: 0.7,
              minSize: 0.2,
            },
            {
              contentConfig: { type: '2D' },
              size: 0.3,
              minSize: 0.2,
            },
          ],
        },
      ],
    },
    {
      label: '2+2',
      paneRows: [
        {
          config: {
            size: 0.5,
            minSize: 0.2,
          },
          cells: [
            {
              contentConfig: { type: '3D' },
              size: 0.5,
              minSize: 0.2,
            },
            {
              contentConfig: { type: '2D' },
              size: 0.5,
              minSize: 0.2,
            },
          ],
        },
        {
          config: {
            size: 0.5,
            minSize: 0.2,
          },
          cells: [
            {
              contentConfig: { type: 'Image', cameraIndex: 0 },
              size: 0.5,
              minSize: 0.2,
            },
            {
              contentConfig: { type: 'Panorama' },
              size: 0.5,
              minSize: 0.2,
            },
          ],
        },
      ],
    },
    {
      label: '2+3',
      paneRows: [
        {
          config: {
            size: 0.5,
            minSize: 0.2,
          },
          cells: [
            {
              contentConfig: { type: '3D' },
              size: 0.5,
              minSize: 0.2,
            },
            {
              contentConfig: { type: '2D' },
              size: 0.5,
              minSize: 0.2,
            },
          ],
        },
        {
          config: {
            size: 0.5,
            minSize: 0.2,
          },
          cells: [
            {
              contentConfig: { type: 'Image', cameraIndex: 0 },
              size: 0.33,
              minSize: 0.2,
            },
            {
              contentConfig: { type: 'Panorama' },
              size: 0.33,
              minSize: 0.2,
            },
            {
              contentConfig: { type: 'Image', cameraIndex: 1 },
              size: 0.33,
              minSize: 0.2,
            },
          ],
        },
      ],
    },
  ],
};
